// src/components/pages/Radiology/Radiology.jsx
import React from "react";
import "./radiology.css";
import Header from "../../Header/Header";
import ServiceShowcase from "../ServiceShowCase.jsx";
import banner from "../../Assets/cover.png";
import premierimage from "../../Assets/premierimage.png";
import Footer from "../../Footer/Footer";
import ServicesGrid from "../ServiceGrid.jsx";
import CardsContainer from "../CardsContainer.jsx";
import {
    heading1, heading2, paragraph1, serviceShowcaseData,
    plethoraOfServices, premierOptionData, transformingData, boonData,
    impactData, settings, truncateLetters, plethoraHeading
} from "./radiologyData.js";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import CoverHero from "../CoverHero.jsx";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import { useNavigate } from "react-router-dom";

const Radiology = () => {
  const navigate = useNavigate();
  
    return (
        <>
            <Header />
            <CoverHero image={banner} title="Radiology" />

            <div className="servicesShowCase">
                {serviceShowcaseData.map((service, index) => (
                    <ServiceShowcase
                        key={index}
                        className="radiology-servicewrapper"
                        data={service}
                        onServiceClick={() => navigate('/')}
                    />
                ))}
                <div className="texts-radiology">
                    <h2>{heading1}</h2>
                    <h3>{heading2}</h3>
                    <p>{paragraph1}</p>
                </div>
            </div>
            
            <CardsContainer
                heading={plethoraHeading}
                services={Object.values(plethoraOfServices)}
            />

            <div className="premier-option">
                <div className="premier-option-content">
                    <div className="premier-option-text">
                        <h2>{premierOptionData.heading}</h2>
                        <ul>
                            {premierOptionData.list.map((item, index) => (
                                <li key={index} className="list-row ">
                                    <span className="check-icon">
                                        {item.icon}
                                    </span>
                                    {item.text}
                                </li>
                            ))}
                        </ul>

                    </div>
                    <div className="premier-option-image">
                        <img src={premierimage} alt="Premier Option" />
                    </div>
                </div>
            </div>
            <div className="transforming-healthcare">
                <div className="transforming-container">
                    <div className="transforming-image">
                        <img src={transformingData.image} alt={transformingData.heading} />
                    </div>

                    <div className="transforming-text">
                        <h2>{transformingData.heading}</h2>
                        <p>{transformingData.paragraph}</p>
                    </div>
                </div>
            </div>

            <div className="boon">
                <h2>A Boon For </h2>
                <div className="boon-grid">
                    {Object.values(boonData).map((item, index) => (
                        <div className="boon-card" key={index}>
                            <img src={item.img} alt={item.title} />
                            <h3>{item.title}</h3>
                        </div>
                    ))}
                </div>
            </div>

            <div className="impact">
                <Testimonials
                    data={impactData}
                    textKey="desc"
                    imgKey="userimg"
                    nameKey="username"
                    settings={settings}
                    className="radiology-testimonials"
                />
            </div>

            <ServicesGrid className="bg-white" title="Check Our Other Services" exclude="Radiology" />
            <Footer />
        </>
    );
};

export default Radiology;
